import { routeNaming } from '../../routes';
import { AboutUs } from '../../pages/information/about-us';
import { BrandService } from '../../pages/information/brand-service';
import { Conditions } from '../../pages/conditions';
import { Contact } from '../../pages/information/contact';
import { Help } from '../../pages/information/help';
import { InformationMenuMobile } from '../../pages/information/information-menu-mobile';
import { JoinOurTeam } from '../../pages/information/join-our-team';
import { Message } from '../../pages/information/message';
import { PanavoxService } from '../../pages/information/panavox-service';
import { ServiceTracking } from '../../pages/information/service-tracking';
import { Shipping } from '../../pages/information/shipping';
import { Terms } from '../../pages/terms';
import { VenuesAndOpenHours } from '../../pages/information/venues-and-open-hours';
import { MyData } from '../../pages/my-account/my-data';
import { MyCredit } from '../../pages/my-account/my-credit';
import { MyOrders } from '../../pages/my-account/my-orders';
import { MyPhoneNumbers } from '../../pages/my-account/my-phone-numbers';
import { Cart } from '../../pages/cart';
import { MyBillingData } from '../../pages/my-account/my-billing-data';
import { PaymentMethodsAndBilling } from '../../pages/payment-methods-and-billing';
import { MyAddresses } from '../../pages/my-account/my-addresses';
import { MyFavorites } from '../../pages/my-account/my-favorites';

const routeConfig = [
  {
    name: routeNaming.VENUES_AND_OPEN_HOURS,
    component: VenuesAndOpenHours,
  },
  {
    name: routeNaming.INFORMATION_MENU_MOBILE,
    component: InformationMenuMobile,
  },
  {
    name: routeNaming.JOIN_OUR_TEAM,
    component: JoinOurTeam,
  },
  {
    name: routeNaming.ABOUT_US,
    component: AboutUs,
  },
  {
    name: routeNaming.PANAVOX_SERVICE,
    component: PanavoxService,
  },
  {
    name: routeNaming.BRAND_SERVICE,
    component: BrandService,
  },
  {
    name: routeNaming.SERVICE_TRACKING,
    component: ServiceTracking,
  },
  {
    name: routeNaming.SHIPPING,
    component: Shipping,
  },
  {
    name: routeNaming.HELP,
    component: Help,
  },
  {
    name: routeNaming.CONTACT,
    component: Contact,
  },
  {
    name: routeNaming.CONDITIONS,
    component: Conditions,
  },
  {
    name: routeNaming.TERMS,
    component: Terms,
  },
  {
    name: routeNaming.MESSAGE,
    component: Message,
  },
  {
    name: routeNaming.MY_DATA,
    component: MyData,
  },
  {
    name: routeNaming.MY_FAVORITES,
    component: MyFavorites,
  },
  {
    name: routeNaming.MY_CREDITS,
    component: MyCredit,
  },
  {
    name: routeNaming.MY_ORDERS,
    component: MyOrders,
  },
  {
    name: routeNaming.MY_PHONE_NUMBERS,
    component: MyPhoneNumbers,
  },
  {
    name: routeNaming.CART,
    component: Cart,
  },
  {
    name: routeNaming.MY_BILLING_DATA,
    component: MyBillingData,
  },
  {
    name: routeNaming.PAYMENT_METHODS_AND_BILLING,
    component: PaymentMethodsAndBilling,
  },
  {
    name: routeNaming.MY_ADDRESSES,
    component: MyAddresses,
  },
];

export { routeConfig };



// WEBPACK FOOTER //
// ./src/apps/static-pages/routes.js